import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithLogout } from "@/lib/baseQuery";
import { ConnectWhatsAppPayload, WhatsAppConnection } from "./whatsapp.type";

/**
 * The restaurant is scoped by the X-Restaurant-Id header added in
 * baseQueryWithLogout, so no restaurant id appears in these paths.
 */
export const WhatsAppApi = createApi({
  reducerPath: "whatsappApi",
  tagTypes: ["whatsappConnection"],
  baseQuery: baseQueryWithLogout,
  endpoints: (build) => ({
    getWhatsAppConnection: build.query<WhatsAppConnection, void>({
      query: () => "whatsapp/connection",
      providesTags: ["whatsappConnection"],
    }),

    connectWhatsApp: build.mutation<WhatsAppConnection, ConnectWhatsAppPayload>({
      query: (body) => ({
        url: "whatsapp/connection",
        method: "POST",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/ld+json",
        },
      }),
      invalidatesTags: ["whatsappConnection"],
    }),

    disconnectWhatsApp: build.mutation<void, void>({
      query: () => ({
        url: "whatsapp/connection",
        method: "DELETE",
      }),
      invalidatesTags: ["whatsappConnection"],
    }),
  }),
});

export const {
  useGetWhatsAppConnectionQuery,
  useConnectWhatsAppMutation,
  useDisconnectWhatsAppMutation,
} = WhatsAppApi;
